module.exports = __webpack_public_path__ + "img/victrix-cinture-7.73aa3bcd.jpg";